import { Box, Paper, Stack, Button } from '@mui/material';
import { useState } from 'react';
import dayjs from 'dayjs';
import HistoryTable from './HistoryTable';
import { exportSettlementsCSV } from '../../services/api/settlements.endpoints';

export default function History() {
    const [isExporting, setIsExporting] = useState(false);
    const [lastExportTime, setLastExportTime] = useState<Date | null>(null);

    const handleExportCSV = async () => {
        try {
            setIsExporting(true);

            const blob = await exportSettlementsCSV();

            // Create download link
            const url = window.URL.createObjectURL(blob);
            const link = document.createElement('a');
            link.href = url;
            link.download = `Delfar_ventas_${dayjs().format('DDMMYY')}.csv`;
            document.body.appendChild(link);
            link.click();
            document.body.removeChild(link);
            window.URL.revokeObjectURL(url);

            // Set last export time for 5-minute disable
            setLastExportTime(new Date());
        } catch (error) {
            console.error('Error exporting CSV:', error);
        } finally {
            setIsExporting(false);
        }
    };

    // Check if button should be disabled (5 minutes haven't passed)
    const isDisabled = () => {
        if (!lastExportTime) return false;
        const fiveMinutesAgo = new Date(Date.now() - 5 * 60 * 1000);
        return lastExportTime > fiveMinutesAgo;
    };

    return (
        <Box sx={{ height: '100%', p: 0 }}>
            <Stack direction="column" height="100%">
                <Box sx={{ display: 'flex', justifyContent: 'flex-end', p: 2 }}>
                    <Button
                        variant="contained"
                        onClick={handleExportCSV}
                        disabled={isExporting || isDisabled()}>
                        {isExporting ? 'Exportando...' : 'Exportar CSV'}
                    </Button>
                </Box>
                <Paper sx={{ overflow: 'auto', flex: 1 }}>
                    <HistoryTable />
                </Paper>
            </Stack>
        </Box>
    );
}
